<template>
  <ul ref="target" :style="style">
    <slot />
  </ul>
</template>

<script setup>
const props = defineProps(["value", "pos"]);
import { useElementVisibility } from "@vueuse/core";
import { useTemplateRef } from "vue";
const target = useTemplateRef("target");
const isVisible = useElementVisibility(target);
const count = props.value + 1;
const pos = props.pos;

const style = ref({});
const _int = ref();

watch(isVisible, (v) => {
  if (v) {
    let val = 0 - pos * 5;
    _int.value = setInterval(() => {
      val += 0.5;
      style.value.top = "-" + val + "px";
      if (val == (count - 1) * 33) clearInterval(_int.value);
    }, 5);
  } else {
    clearInterval(_int.value);
    style.value.top = 0;
  }
});
</script>
